import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb05208"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 全部 ")

import { reactive, ref, watch, computed, PropType } from "vue";
import { onClickOutside } from "@vueuse/core";

interface ListItem {
  value: string;
  label: string;
}

interface MultipleState {
  indeterminate: boolean;
  checkAll: boolean;
  showSelectList: boolean;
}


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "MultipleSelect",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: Array as PropType<ListItem[]>,
    required: true,
    default: () => [],
  },
  list: {
    type: Array as PropType<ListItem[]>,
    default: () => [],
  },
  placeholder: {
    type: String,
    defautl: "请选择",
  },
  maxTagCount: {
    type: Number,
    default: null,
  },
  maxTagTextLength: {
    type: Number,
    default: null,
  },
  className: {
    type: String,
    default: "",
  },
},
  emits: ["update:value"],
  setup(__props, { emit }) {

const props = __props

const VNodes = (_, { attrs }) => {
  return attrs.vnodes;
};




const titleValue = computed(() => {
  return props.value.map((item) => item.label).join(",");
});
const selectedData = computed({
  get: () => props.value,
  set(val: ListItem[]) {
    emit("update:value", val);
  },
});

const state = reactive<MultipleState>({
  indeterminate: false,
  checkAll: false,
  showSelectList: false,
});

const checkedList = computed({
  get() {
    return props.value.map((item) => item.value);
  },
  set(val: string[]) {
    // console.log(val, "编辑");
    selectedData.value = props.list.reduce<ListItem[]>((total, ele) => {
      if (val.includes(ele.value)) {
        total.push(ele);
      }
      return total;
    }, []);
  },
});

function onCheckAllChange(e: any) {
  state.indeterminate = false;
  selectedData.value = e.target.checked ? props.list : [];
}

watch(
  () => props.value,
  (val) => {
    state.indeterminate = !!val.length && val.length < props.list.length;
    state.checkAll = val.length === props.list.length;
  }
);

const dropDrownRef = ref(null);
const selectRef = ref(null);

onClickOutside(
  dropDrownRef,
  () => {
    state.showSelectList = false;
  },
  { ignore: [selectRef] }
);

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    ref_key: "selectRef",
    ref: selectRef,
    value: _unref(selectedData),
    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedData) ? (selectedData).value = $event : null)),
    mode: "multiple",
    placeholder: __props.placeholder,
    labelInValue: "",
    "allow-clear": "",
    open: state.showSelectList,
    options: __props.list,
    "option-filter-prop": "label",
    "max-tag-count": __props.maxTagCount,
    "max-tag-text-length": __props.maxTagTextLength,
    class: _normalizeClass(__props.className),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (state.showSelectList = true))
  }, {
    maxTagPlaceholder: _withCtx((omittedValues) => [
      _createElementVNode("span", {
        style: {"color":"red"},
        title: _unref(titleValue)
      }, "+ " + _toDisplayString(omittedValues.length) + " ...", 9, _hoisted_1)
    ]),
    option: _withCtx(({ label, value }) => [
      _createVNode(_component_a_checkbox, { value: value }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(label), 1)
        ]),
        _: 2
      }, 1032, ["value"])
    ]),
    dropdownRender: _withCtx(({ menuNode: menu }) => [
      _createElementVNode("div", {
        ref_key: "dropDrownRef",
        ref: dropDrownRef
      }, [
        _createVNode(_component_a_checkbox, {
          class: "controll-all",
          checked: state.checkAll,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((state.checkAll) = $event)),
          indeterminate: state.indeterminate,
          onChange: onCheckAllChange
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["checked", "indeterminate"]),
        _createVNode(_component_a_divider, { style: {"margin":"0"} }),
        _createVNode(_component_a_checkbox_group, {
          value: _unref(checkedList),
          class: "my-group"
        }, {
          default: _withCtx(() => [
            _createVNode(VNodes, { vnodes: menu }, null, 8, ["vnodes"])
          ]),
          _: 2
        }, 1032, ["value"])
      ], 512)
    ]),
    _: 1
  }, 8, ["value", "placeholder", "open", "options", "max-tag-count", "max-tag-text-length", "class"]))
}
}

})